(function () {
    'use strict';

    angular
        .module('smartertoolsApp')
        .component('passwordEntropy', {
            template: `
                <div class='password-strength' ng-class='{
                    "password-strength-very-weak": $ctrl.Entropy == 0,
                    "password-strength-weak": $ctrl.Entropy == 1,
                    "password-strength-medium": $ctrl.Entropy == 2,
                    "password-strength-strong": $ctrl.Entropy == 3,
                    "password-strength-very-strong": $ctrl.Entropy == 4,
                    "password-strength-has-suggestions": $ctrl.Feedback.Warning
                    }'>
                    <div class='tag' ng-if='$ctrl.Entropy == 0'>Password is Too Weak</div>
                    <div class='tag' ng-if='$ctrl.Entropy == 1'>Password is Too Weak</div>
                    <div class='tag' ng-if='$ctrl.Entropy == 2'>Password is Acceptable</div>
                    <div class='tag' ng-if='$ctrl.Entropy == 3'>Password is Strong</div>
                    <div class='tag' ng-if='$ctrl.Entropy == 4'>Password is Very Strong</div>
                    <div class='suggestions' ng-if='$ctrl.Feedback.Warning'>
                        <div>{{$ctrl.Feedback.Warning}}</div>
                    </div>
                </div>`,
            controller: passwordEntropy,
            bindings: {
                password: '=',
                calculatedEntropy: '='
            }
        });

    /* @ngInject */
    function passwordEntropy($rootScope, $scope, $http) {
        const vm = this;
        vm.entropy = 0;
        vm.lastPassword = null;
        const debouncedCheckPassword = _.debounce(checkPassword, 100);

        // -----------------------------------------------

        vm.$onInit = function () {
        };

        vm.$doCheck = function () {
            if (vm.password != vm.lastPassword) {
                vm.lastPassword = vm.password;
                debouncedCheckPassword();
            }
        };

        vm.$onChanges = function (changesObj) {
        };

        async function checkPassword() {
            try {
                const passwordChecking = vm.password;
                if (vm.password === null || vm.password === undefined || vm.password === '') {
                    $scope.$applyAsync(() => {
                        vm.Entropy = -1;
                        vm.calculatedEntropy = -1;
                        vm.Feedback = null;
                    });
                    return;
                }
                const result = await $http.post(`${apiRootUrl}v1/password-strength/calculate`, JSON.stringify({password: passwordChecking}));
                if (passwordChecking == vm.password) {
                    $scope.$applyAsync(() => {
                        vm.Entropy = result.data.Score;
                        vm.calculatedEntropy = vm.Entropy;
                        vm.Feedback = result.data.Feedback;
                    });
                }
            } catch (err) {
                // -2 is allowed and will not show any message. If the backend requires it, it will throw a backend error
                console.log(err);
                vm.Entropy = -2;
                vm.calculatedEntropy = -2;
                vm.Feedback = null;
            }
        }
    }

})();
